import { useDiagramContext } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/contexts/DiagramContext';

interface DiagramCircleProps {
  cx: number;
  cy: number;
  r: number;
}

export const DiagramCircle = ({ cx, cy, r }: DiagramCircleProps) => {
  const { colors } = useDiagramContext();

  return <circle cx={cx} cy={cy} r={r} fill="none" stroke={colors.bar} strokeWidth={1.2} />;
};
